import isCignaPlan from 'utils/pivot/plan/isCignaPlan'
import isRXPlan from 'utils/pivot/plan/isRXPlan'

function getPlanTypeKey<T extends Plan>(plan: T): string | undefined {
  if (!plan) {
    return undefined
  }

  let planTypeKey = plan.type
  if (plan.type === 'epic') {
    if (isRXPlan(plan)) {
      planTypeKey += `-rx`
    }
    if (isCignaPlan(plan)) {
      planTypeKey += `-cigna`
    }
  } else if (plan.type === 'quantum') {
    if (plan.coreBenefits.quantumType === 'copay') {
      planTypeKey += `-copay`
    }
  }

  if (plan?.multiCarrierPlan) planTypeKey = 'multi'

  return planTypeKey
}

export default getPlanTypeKey
